import {COUNTRIES_LIST} from './countries';
import {REGIONS} from './regions';

export const IS_LOCALHOST = window.location.origin.includes('localhost');
export const IS_DEVELOPMENT = process.env.REACT_APP_ENV === 'development';
export const IS_DEMO = process.env.REACT_APP_ENV === 'demo';
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
export const MAP_TYPE = (process.env.REACT_APP_GEO || 'GOOGLE') as 'GOOGLE' | 'YANDEX';

export type ENVIRONMENTS = 'development' | 'demo' | 'stage' | 'production';

export type COUNTRIES = typeof COUNTRIES_LIST[number];
export const COUNTRY = process.env.REACT_APP_COUNTRY?.toUpperCase() as COUNTRIES;
export const COUNTRY_NAMING = REGIONS[COUNTRY];

export const ALPHA_2_COUNTRY = REGIONS[COUNTRY]?.short;
export const MAP_CENTER = (REGIONS[COUNTRY] || REGIONS.CAR).center;

export const IS_NG = COUNTRY === 'NG';
export const IS_CAR = COUNTRY === 'CAR';
export const IS_TJ = COUNTRY === 'TJ';
export const IS_BA = COUNTRY === 'BA';
